import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "outer" }

import { ref, useTemplateRef } from 'vue';
import { useRoute } from 'vue-router';

import { showError } from '@services/utils/dialog';

import NcButton from '@nextcloud/vue/components/NcButton';

import FaceList from './FaceList.vue';
import Modal from './Modal.vue';

import { useModal } from '@services/modal';
import { t } from '@services/l10n';
import { isAbortError, useAbort } from '@services/utils/abort-vue';
import * as dav from '@services/dav';
import * as utils from '@services/utils/common';

import type { IPhoto, IFace } from '@typings';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'FaceMoveModal',
},
  __name: 'FaceMoveModal',
  setup(__props) {



const route = useRoute();
const modal = useTemplateRef('modal');
const { show, close } = useModal(modal);

const photos = ref<IPhoto[]>([]);
const abort = useAbort();

console.assert(!_m.modals.moveToFace, 'FaceMoveModal created twice');
_m.modals.moveToFace = open;

function open(photosIn: IPhoto[]) {
  if (photos.value.length) {
    // is processing
    return;
  }

  // check ownership
  const user = route.params.user?.toString() || '';
  if (route.params.user?.toString() !== utils.uid) {
    showError(
      t('memories', 'Only user "{user}" can update this person', {
        user,
      }),
    );
    return;
  }

  show.value = true;
  photos.value = photosIn;
}

function cleanup() {
  abort.abort();
  show.value = false;
  photos.value = [];
}

function moved(photosIn: IPhoto[]) {
  utils.bus.emit('memories:timeline:deleted', photosIn);
}

async function clickFace(face: IFace) {
  const user = route.params.user?.toString() || '';
  const name = route.params.name?.toString() || '';
  const target = String(face.name || face.cluster_id);

  if (
    !(await utils.confirmDestructive({
      title: t('memories', 'Move to person'),
      message: t('memories', 'Move the selected photos to {target}?', {
        target: utils.isNumber(target) ? t('memories', 'Unnamed person') : target,
      }),
      confirm: t('memories', 'Move'),
      confirmClasses: 'primary',
      cancel: t('memories', 'Cancel'),
    }))
  ) {
    return;
  }

  try {
    // Create map to return IPhoto later
    const map = new Map<number, IPhoto>();
    for (const photo of photos.value.filter((p) => p.faceid)) {
      map.set(photo.faceid!, photo);
    }

    // Run WebDAV query
    const signal = abort.renew();
    const photosArr = Array.from(map.values());
    for await (let delIds of dav.recognizeMoveFaceImages(user, name, target, photosArr, { signal })) {
      signal.throwIfAborted();
      moved(
        delIds
          .filter(utils.truthy)
          .map((id) => map.get(id))
          .filter(utils.truthy),
      );
    }
  } catch (error) {
    if (isAbortError(error)) return;
    console.error(error);
    showError(t('memories', 'An error occurred while moving photos from {name}.', { name }));
  } finally {
    close();
  }
}

return (_ctx: any,_cache: any) => {
  return (_unref(show))
    ? (_openBlock(), _createBlock(Modal, {
        key: 0,
        ref_key: "modal",
        ref: modal,
        onClose: cleanup,
        size: "large"
      }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('memories', 'Move selected photos to person')), 1)
        ]),
        buttons: _withCtx(() => [
          _createVNode(_unref(NcButton), {
            onClick: _unref(close),
            class: "button",
            variant: "error"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('memories', 'Cancel')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(FaceList, {
              plus: true,
              onSelect: clickFace
            })
          ])
        ]),
        _: 1
      }, 512))
    : _createCommentVNode("", true)
}
}

})